<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead class="tw:text-left tw:text-sm tw:bg-zinc-50">
        <tr>
          <th>{{ $t('Date') }}</th>
          <th>{{ $t('Agent') }}</th>
          <th>{{ $t('Model') }}</th>
          <th class="tw:hidden tw:md:table-cell tw:print:table-cell">{{ $t('Charged to') }}</th>
          <th class="tw:hidden tw:lg:table-cell tw:print:table-cell">{{ $t('Event') }}</th>
          <th class="tw:text-right">{{ $t('Input tokens') }}</th>
          <th class="tw:text-right">{{ $t('Output tokens') }}</th>
          <th class="tw:hidden tw:sm:table-cell tw:print:table-cell tw:text-right">{{ $t('Duration') }}</th>
          <th>{{ $t('Status') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="usage in usages" :key="usage.id">
          <td class="tw:whitespace-nowrap">
            <a :href="usage.show_url">{{ dayjs(usage.created_at).format('lll') }}</a>
            <div v-if="usage.step > 0" class="tw:text-xs tw:text-zinc-500">
              {{ $t('Step {step}', { step: usage.step + 1 }) }}
            </div>
          </td>

          <td>{{ usage.agent }}</td>

          <td class="tw:whitespace-nowrap">
            <div class="tw:font-mono tw:text-xs">{{ usage.model }}</div>
            <div class="tw:text-xs tw:text-zinc-500">{{ usage.provider }}</div>
          </td>

          <td class="tw:hidden tw:md:table-cell tw:print:table-cell">
            <AiUsageEntity :entity="usage.billable" />
          </td>

          <td class="tw:hidden tw:lg:table-cell tw:print:table-cell">
            <AiUsageEntity :entity="usage.tour" :with-type="false" />
          </td>

          <td class="tw:text-right tw:tabular-nums">
            {{ formatNumber(usage.input_tokens) }}
            <div v-if="usage.cache_read_input_tokens" class="tw:text-xs tw:text-zinc-500">
              {{ $t('{count} cached', { count: formatNumber(usage.cache_read_input_tokens) }) }}
            </div>
          </td>

          <td class="tw:text-right tw:tabular-nums">
            {{ formatNumber(usage.output_tokens) }}
            <div v-if="usage.reasoning_tokens" class="tw:text-xs tw:text-zinc-500">
              {{ $t('{count} reasoning', { count: formatNumber(usage.reasoning_tokens) }) }}
            </div>
          </td>

          <td class="tw:hidden tw:sm:table-cell tw:print:table-cell tw:text-right tw:tabular-nums tw:whitespace-nowrap">
            {{ formatNumber(usage.duration_ms) }} ms
          </td>

          <td>
            <Badge :variant="usage.status === 'failed' ? 'red' : 'green'" :title="usage.error ?? undefined">
              {{ usage.status_label }}
            </Badge>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import { Badge } from '@/components/ui/badge'
import AiUsageEntity from './AiUsageEntity.vue'
import { formatNumber } from './format'

defineProps({
  usages: {
    type: Array,
    required: true,
  },
})
</script>
